<!-- NAME -->
<td>{{ (displayableFileObj.name.length > 50)? (displayableFileObj.name | slice:0:45) + '...':(displayableFileObj.name) }}</td>

<!-- SIZE -->
<td>{{ displayableFileObj.size | byteFormatter }}</td>

<!-- UPLOAD / STATUS -->
<td>

  <!-- UPLOAD BUTTON -->
  @if (validForUpload && !successfullySubmitted) {
    <div class="icon-text"
      matTooltip="This file is ready for upload."
      >
      <!-- Ready -->
      <button mat-raised-button color="primary"
        [disabled]="!(validForUpload && canUploadMoreFiles) || disabledUploadDueToDropdownLogic"
        (click)="uploadSingleFile()">
        Upload
      </button>
    </div>
  }

  <!-- BAD STATUS -->
  @if (!validForUpload && !isPending && !successfullySubmitted) {
    <div class="icon-text"
      matTooltip="This file does not meet the upload requirements."
      >
      <span class="material-symbols-outlined warning-color">highlight_off</span>
    </div>
  }

  <!-- GOOD STATUS -->
  @if (successfullySubmitted) {
    <div class="icon-text"
      matTooltip="This file was successfully uploaded."
      color="primary">
      <!-- Success -->
      <span class="material-symbols-outlined primary-color">check_circle</span>
    </div>
  }

  @if (isPending) {
    <div class="pending-spinner">
      <mat-spinner [diameter]="24"></mat-spinner>
    </div>
  }

</td>

<!-- REMOVE -->
<td>
  <div class="icon-text">

    @if (disableRemoveButton) {
      <!-- Non-interactable -->
      <span class="material-symbols-outlined trash-icon disabled">delete</span>
    } @else {
      <!-- Interactable -->
      <span
        class="material-symbols-outlined trash-icon"
        matTooltip="Click here to remove this file."
      (click)="removeSingleFile()">delete</span>
    }

  </div>
</td>
